
function getLanguage() {
    let l = document.querySelector('html').getAttribute('lang');
    return Boolean(l) ? l : 'am';
}

function getLanguageFromURL() {
    let langs = ['am', 'ru', 'en'];
    let l = location.pathname.split('/')[1];
    return langs.includes(l) ? l : null;
}

function setURLLanguage(lang) {
    let currentLang = getLanguageFromURL();
    if(currentLang)
    {
        location.href = location.pathname.replace(currentLang,lang) + location.search;
        return;
    }
    location.href = "/" + lang + location.pathname + location.search;
}

function init() {
    let lang = getLanguage();

    if (!getLanguageFromURL()) {
        setURLLanguage(lang);
    }

    let activeElement = document.querySelector('#languages a[data-value="' + lang + '"]');

    if (activeElement) {
        activeElement.classList.add("active");

        let title = activeElement.innerText;
        activeElement.parentElement.innerHTML = `<span title="${title}">${title}</span>`
    }

    $("#languages a").on('click', e => {
        e.preventDefault();
        let newLang = e.target.getAttribute('data-value');

        if (newLang == lang) return;

        setURLLanguage(newLang);
    });
}

module.exports = {init, getLanguage};